// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderTopOutlinedSvg from "@fishx/icons-svg/es/asn/BorderTopOutlined";
import FishxIcon from '../components/FishxIcon';

var BorderTopOutlined = function BorderTopOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderTopOutlinedSvg
  }));
};

BorderTopOutlined.displayName = 'BorderTopOutlined';
export default React.forwardRef(BorderTopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BorderTopOutlined.js
// module id = 2106
// module chunks = 0